import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import CreateBusinessItem from "./CreateBusinessItem";
import { getDropdownData, createItemRequest, fetchBrandAndHsn } from "services/redux/businessItems/action";

const mapStateToProps = (state) => ({
  dropdownData: state.businessItemReducer.dropdownData,
  brandAndHsnData: state.businessItemReducer.brandAndHsnData
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getDropdownData,
      createItemRequest,
      fetchBrandAndHsn,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(CreateBusinessItem);
